import { styled } from "@mui/material/styles";
import { TableBody } from "../TableBody";

export const SelectionTableBody = styled(TableBody)(({ theme }) => ({
  "& tr": {
    "&:hover": {
      borderRadius: "1.25rem",
      "& td": {
        backgroundColor: theme.palette.primary.main,
        "&:first-of-type": {
          borderTopLeftRadius: "1.25rem",
          borderBottomLeftRadius: "1.25rem",
          boxShadow: "inset 0.25rem 0 0 #92FBB3",
        },
        "&:last-of-type": {
          borderTopRightRadius: "1.25rem",
          borderBottomRightRadius: "1.25rem",
        },
      },
    },
  },
  "& td": {
    borderBottom: "none",
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.25rem",
    paddingTop: "25px",
    paddingBottom: "25px",
    border: "none",
  },
}));
export default SelectionTableBody;
